module.exports = __webpack_public_path__ + "static/step2-6b1c932d791d0e0fb4c13deb561a4242.svg";